import { Component, EventEmitter, Output } from '@angular/core';
import { UI_TOOLS_MATOMO_EVENT_CATEGORY_HEADER } from '../../ui-tools-matomo-events';

/**
 * Styled with:
 * - --btn-width: the width of button
 * - --btn-heigh: the height of button
 * - --btn-line-height: the line-height of button
 * - --btn-background: the background of button
 * - --btn-close-top: the distance from top to the button
 * - --btn-close-right: the distance from right to the button
 * - --btn-padding: the padding of button
 * - --shadow: the shadow of button
 */

@Component({
  selector: 'yat-button-close-modal',
  templateUrl: './button-close-modal.component.html',
  styleUrls: ['./button-close-modal.component.scss']
})
export class ButtonCloseModalComponent {
  @Output()
  clickMethod: EventEmitter<void> = new EventEmitter();

  readonly MATOMO_EVENT_CATEGORY_HEADER = UI_TOOLS_MATOMO_EVENT_CATEGORY_HEADER;

  onClick(): void {
    this.clickMethod.emit();
  }
}
